import {otsBaseApi} from "../../ots-api";
import {Region} from "../../../model/region";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["Regions"]});

export const regionApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRegions: builder.query<Region[], void>({
      query: () => ({
        url: `/regions/all`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "Regions", id} as const)),
            {type: "Regions", id: "LIST"}
          ];
        } else {
          return [{type: "Regions", id: "LIST"}];
        }
      }
    }),
    /** The regions the signed-in user can work in. The server returns an empty list when they have none. */
    getAccessibleRegions: builder.query<Region[], void>({
      query: () => ({
        url: `/regions/accessible`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "Regions", id} as const)),
            {type: "Regions", id: "LIST"}
          ];
        } else {
          return [{type: "Regions", id: "LIST"}];
        }
      }
    }),
    getRegion: builder.query<Region, string>({
      query: (id) => ({
        url: `/regions/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, id) => [{type: "Regions", id}]
    })
  })
});

export const {
  useGetAllRegionsQuery,
  useGetAccessibleRegionsQuery,
  useGetRegionQuery
} = regionApi;
